import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#f3f6fa',
        color: '#17324d',
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: 'min(100%, 1100px)',
          padding: '32px 32px 28px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            fontSize: '0.9rem',
            fontWeight: 700,
            letterSpacing: '0.08em',
            color: '#365a7c',
            marginBottom: '20px',
          }}
        >
          AGILE MANUFACTURING EXCHANGE
        </div>

        <img
          src='/images/AMX-Logo.png'
          alt='AMX logo'
          style={{
            width: 'min(100%, 620px)',
            maxHeight: '30vh',
            objectFit: 'contain',
            height: 'auto',
            marginBottom: '24px',
          }}
        />

        <h1
          style={{
            margin: '0 0 14px',
            fontSize: 'clamp(2rem, 4.2vw, 3.15rem)',
            lineHeight: 1.08,
            color: '#10263c',
            maxWidth: '900px',
          }}
        >
          Secure collaboration for advanced manufacturing partners
        </h1>

        <p
          style={{
            maxWidth: '820px',
            margin: '0 0 12px',
            fontSize: '1rem',
            lineHeight: 1.65,
            color: '#42627f',
          }}
        >
          AMX connects manufacturers, suppliers, academia and innovators through a secure, real-time exchange.
          Discover capabilites, share data, and coordinate production seamlessly across distributed environments.
          Accelerate decision-making and unlock agile manufacturing at scale. 
        </p>

        <p
          style={{
            maxWidth: '820px',
            margin: '0 0 28px',
            fontSize: '1rem',
            lineHeight: 1.65,
            color: '#42627f',
          }}
        >
          If you've received an invitation, log in to access your workspace and begin collaborating.
          New to AMX?
        </p>

        <div
          style={{
            display: 'flex',
            gap: '16px',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <button
            type='button'
            onClick={() => navigate('/login')}
            style={{
              minWidth: '210px',
              border: 'none',
              borderRadius: '999px',
              backgroundColor: '#1f5f99',
              color: '#ffffff',
              padding: '16px 30px',
              fontSize: '1.08rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Login
          </button>

          <button
            type='button'
            style={{
              minWidth: '210px',
              border: '1px solid #9eb6cd',
              borderRadius: '999px',
              backgroundColor: '#f5f8fb',
              color: '#4b6783',
              padding: '16px 30px',
              fontSize: '1.08rem',
              fontWeight: 600,
              cursor: 'default',
            }}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
}
